import styled from 'styled-components';
import {
  Popup as SemanticPopup,
  Image as SemanticImage,
  Modal as SemanticModal,
} from 'semantic-ui-react';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Text = styled(TextLayoutComponent)`
  word-break: break-word;

  ${({ tooltip }) => tooltip && `
    font-size: 12px;
  `}
`;

export const Popup = styled(SemanticPopup)`
  &.ui.popup {
    background: ${({ theme }) => theme.color.tooltipDescription};
    border: solid 1px ${({ theme }) => theme.color.tooltipDescription};

    :before {
      background: ${({ theme }) => theme.color.tooltipDescription};
      box-shadow: 1px 1px 0 0 ${({ theme }) => theme.color.tooltipDescription};
    }
  }
`;

export const TooltipDescription = styled.div`
  display: flex;
  background: ${({ theme }) => theme.color.tooltipDescription};
  padding: 2px;
  width: 20px;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  cursor: pointer;
`;

export const Image = styled(SemanticImage)`
  max-width: 90px;
  max-height: 60px;
  cursor: pointer;
`;

export const ContainerImageName = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Modal = styled(SemanticModal)`
  height: 100vh;
  width: 100vw;
  &.ui.modal {
    height: 70%;
    width: 70%;
    max-width: 1345px;
    max-height: 700px;
  }
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  height: 100%;
  width: 100%;
  padding: 3%;
`;

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80%;
  height: 80%;
`;

export const ModalImage = styled(SemanticImage)`
  max-width: 100%;
  max-height: 100%;
`;

export const Link = styled.a`
  color: ${({ theme }) => theme.color.link};
  text-decoration: none;
  cursor: pointer;
  font-weight: 400;
`;
